import { CircularProgress, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getKeyOptions } from "../../helpers/services/ContractServices";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const Key = (props) => {
  const {
    id,
    error,
    readonly,
    helperText,
    label,
    onChange,
    meta_id,
    value,
    onBlur,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const { isLoading, data: options = [] } = useQuery({
    queryKey: ["key"],
    queryFn: () => getKeyOptions(meta_id),
  });

  function normalizeValue() {
    if (value === null || isEmpty(options)) {
      return null;
    }

    const matchedOption = options.find((option) => {
      return option.id === value.id;
    });

    return matchedOption || null;
  }

  function handleOnChange(_e, value) {
    onChange(value ? value : null);
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        className={classes.autoComplete}
        onBlur={onBlur}
        value={normalizeValue()}
        onChange={handleOnChange}
        options={options}
        loading={isLoading}
        getOptionLabel={(option) => {
          return option.short_name;
        }}
        getOptionSelected={(option, value) => {
          return option.id === value.id;
        }}
        renderOption={(option) => {
          return <Typography noWrap>{option.short_name}</Typography>;
        }}
        disabled={readonly}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            variant="outlined"
            name={label}
            label={label}
            InputProps={{
              ...params.InputProps,
              autoComplete: "new-password",
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            error={error}
            helperText={helperText}
          />
        )}
        disableListWrap
        noOptionsText={t(`system.nokey`)}
      />
    </div>
  );
};

export default Key;
